import React, { useEffect, useState } from "react";
import { Sidebar as PrimeSidebar } from "primereact/sidebar";
import { Timeline } from "primereact/timeline";
import { Button } from "primereact/button";
import { getStops } from "./Sidebar.service";
import "./Sidebar.scss";

interface IStops {
    nombre: string,
    hora_programada: string,
    hora_registro: string,
    hora_estimada: string,
}

interface SidebarProps {
    idTrazo: number | null;
    idBitacora: number | null;
}

const Sidebar: React.FC<SidebarProps> = ({ idTrazo, idBitacora }) => {
    const [visible, setVisible] = useState(false);
    const [stops, setStops] = useState<IStops[]>([]);

    useEffect(() => {
        if (!idTrazo) return;

        let cancelled = false;
        let intervalId: ReturnType<typeof setInterval>;

        const fetchStops = async () => {
            try {
                const data = await getStops(idTrazo, idBitacora as number);
                if (cancelled) return;

                setStops(data.paradas);

                // Si el turno ya terminó, dejamos de consultar pero las paradas quedan visibles
                if (!data.enRuta) clearInterval(intervalId);
            } catch (error) {
                console.error("Error fetching stops:", error);
            }
        };

        fetchStops();
        intervalId = setInterval(fetchStops, 120000);

        return () => {
            cancelled = true;
            clearInterval(intervalId);
        };
    }, [idBitacora, idTrazo]);

    return (
        <>
            <Button
                icon={visible ? "pi pi-chevron-right" : "pi pi-chevron-left"}
                className="stops-toggle-btn"
                onClick={() => setVisible(true)}
                rounded
            />
            <PrimeSidebar
                visible={visible}
                position="right"
                modal={false}
                dismissable={false}
                onHide={() => setVisible(false)}
                className="stops-sidebar"
                header={<span><i className="pi pi-map-marker" /> Paradas</span>}
            >
                {stops.length > 0 ? (
                    <Timeline
                        value={stops}
                        align="left"
                        marker={(item: IStops) => (
                            <span
                                className="stop-marker"
                                style={{ backgroundColor: item.hora_registro ? '#d97706' : '#9e9e9e' }}
                            >
                                <i className="pi pi-map-marker" />
                            </span>
                        )}
                        content={(item: IStops) => (
                            <div className="stop-content">
                                <h4>{item.nombre}</h4>
                                <p><i className="pi pi-clock" /> Programada: {item.hora_programada}</p>
                                <span className="stop-registro">
                                    Registro: {item.hora_registro || 'Sin registro'}
                                </span>
                                {!item.hora_registro && (
                                    <span className="stop-estimada">
                                        Estimada: {item.hora_estimada}
                                    </span>
                                )}
                            </div>
                        )}
                        className="w-full"
                    />
                ) : (
                    <div className="stops-empty">
                        <i className="pi pi-info-circle" />
                        <span>Aún no hay paradas registradas</span>
                    </div>
                )}
            </PrimeSidebar>
        </>
    );
};

export default Sidebar;
